import React, { useEffect } from 'react';
import { PageTitle, Alert } from '@gsa/afp-component-library';
import WelcomeMessage from '../../../widgets/welcome-message';
import FvsPreBidSelectionProvider from './pre-bid-report-provider';
import Breadcrumbs from '../../../widgets/breadcrumbs';
import PreBidReportTable from './pre-bid-report-table';
import PreBidReportMessages from './pre-bit-report-message';

const PreBidReportPage = () => {
  const [alert, setAlert] = React.useState(null);
  useEffect(() => {
    document.title = 'Pre-bid Report - GSAFleet.gov';
  }, []);

  const breadcrumbsPath = [
    {
      location: `${window.AFP_CONFIG.appURLs.home}/home`,
      label: 'Home',
    },
    {
      location: '/catalog/vehicle-standards',
      label: 'Federal Vehicle Standards',
    },
  ];

  return (
    <FvsPreBidSelectionProvider>
      <div>
        {alert && (
          <Alert slim focused type={alert.type} onClose={() => setAlert(null)}>
            {alert.message}
          </Alert>
        )}
        <Breadcrumbs
          current="Vendor Pre-Bid Selections"
          path={breadcrumbsPath}
        />
        <PreBidReportMessages />
        <PageTitle
          aria-label="Vendor Pre-Bid Selections"
          tabIndex="0"
          title="Vendor Pre-Bid Selections"
        />
        <WelcomeMessage message="The Vendor pre-bid selection page displays the intention to bid by Standard item expressed by the Vehicle suppliers across all the federal standard codes." />
        <PreBidReportTable setAlert={setAlert} />
      </div>
    </FvsPreBidSelectionProvider>
  );
};

export default PreBidReportPage;
